import axios from "axios";
import { baseUrl } from "./apiConfig";

const client = axios.create({
  baseURL: `${baseUrl}/human-in-loop`,
  timeout: 20000,
});

const unwrap = (response) => response.data;

export const getHumanInLoopError = (error, fallback = "Request failed") => {
  const data = error?.response?.data;
  const message =
    data?.message?.message ||
    data?.message ||
    data?.detail?.message ||
    data?.detail ||
    data?.error ||
    error?.message ||
    fallback;
  return typeof message === "string" ? message : JSON.stringify(message);
};

export const humanInLoopApi = {
  getDrivers: () => client.get("/drivers").then(unwrap),
  getTourEditor: (tourId) => client.get(`/tours/${tourId}/editor`).then(unwrap),
  previewMergeTours: (payload) => client.post("/tours/merge-preview", payload).then(unwrap),
  mergeTours: (payload) => client.post("/tours/merge", payload).then(unwrap),
  getBookingState: (bookingId) =>
    client.get(`/bookings/${bookingId}/allocation-state`).then(unwrap),

  createEditSession: (payload) => client.post("/edit-sessions", payload).then(unwrap),
  heartbeat: (sessionId, ttlSec = 300) =>
    client.post(`/edit-sessions/${sessionId}/heartbeat`, { ttl_sec: ttlSec }).then(unwrap),
  release: (sessionId) => client.delete(`/edit-sessions/${sessionId}`).then(unwrap),

  editTourAssignments: (tourId, payload) =>
    client.post(`/tours/${tourId}/assignments`, payload).then(unwrap),
  resequenceTour: (tourId, payload) =>
    client.post(`/tours/${tourId}/resequence`, payload).then(unwrap),
  assignBooking: (bookingId, payload) =>
    client.post(`/bookings/${bookingId}/assign`, payload).then(unwrap),
  reassignBooking: (bookingId, payload) =>
    client.post(`/bookings/${bookingId}/reassign`, payload).then(unwrap),
  unassignBooking: (bookingId, payload) =>
    client.post(`/bookings/${bookingId}/unassign`, payload).then(unwrap),
};


// import axios from "axios";
// import { baseUrl } from "./apiConfig";

// const client = axios.create({
//   baseURL: `${baseUrl}/human-in-loop`,
//   timeout: 20000,
// });

// const unwrap = (response) => response.data;

// export const getHumanInLoopError = (error, fallback = "Request failed") => {
//   const data = error?.response?.data;
//   const message =
//     data?.message?.message ||
//     data?.message ||
//     data?.detail?.message ||
//     data?.detail ||
//     data?.error ||
//     error?.message ||
//     fallback;
//   return typeof message === "string" ? message : JSON.stringify(message);
// };

// export const humanInLoopApi = {
//   getDrivers: () => client.get("/drivers").then(unwrap),
//   getTourEditor: (tourId) => client.get(`/tours/${tourId}/editor`).then(unwrap),
//   previewMergeTours: (payload) => client.post("/tours/merge-preview", payload).then(unwrap),
//   mergeTours: (payload) => client.post("/tours/merge", payload).then(unwrap),
//   getBookingState: (bookingId) =>
//     client.get(`/bookings/${bookingId}/allocation-state`).then(unwrap),

//   createEditSession: (payload) => client.post("/edit-sessions", payload).then(unwrap),
//   heartbeat: (sessionId, ttlSec = 300) =>
//     client.post(`/edit-sessions/${sessionId}/heartbeat`, { ttl_sec: ttlSec }).then(unwrap),
//   release: (sessionId) => client.delete(`/edit-sessions/${sessionId}`).then(unwrap),

//   resequenceTour: (tourId, payload) =>
//     client.post(`/tours/${tourId}/resequence`, payload).then(unwrap),
//   assignBooking: (bookingId, payload) =>
//     client.post(`/bookings/${bookingId}/assign`, payload).then(unwrap),
//   reassignBooking: (bookingId, payload) =>
//     client.post(`/bookings/${bookingId}/reassign`, payload).then(unwrap),
//   unassignBooking: (bookingId, payload) =>
//     client.post(`/bookings/${bookingId}/unassign`, payload).then(unwrap),
// };


// // import axios from "axios";
// // import { baseUrl } from "./apiConfig";

// // const client = axios.create({
// //   baseURL: `${baseUrl}/human-in-loop`,
// //   timeout: 20000,
// // });

// // const unwrap = (response) => response.data;

// // export const getHumanInLoopError = (error, fallback = "Request failed") => {
// //   const data = error?.response?.data;
// //   const message =
// //     data?.message?.message ||
// //     data?.message ||
// //     data?.detail?.message ||
// //     data?.detail ||
// //     data?.error ||
// //     error?.message ||
// //     fallback;
// //   return typeof message === "string" ? message : JSON.stringify(message);
// // };

// // export const humanInLoopApi = {
// //   getDrivers: () => client.get("/drivers").then(unwrap),
// //   getTourEditor: (tourId) => client.get(`/tours/${tourId}/editor`).then(unwrap),
// //   getBookingState: (bookingId) =>
// //     client.get(`/bookings/${bookingId}/allocation-state`).then(unwrap),

// //   createEditSession: (payload) => client.post("/edit-sessions", payload).then(unwrap),
// //   heartbeat: (sessionId, ttlSec = 300) =>
// //     client.post(`/edit-sessions/${sessionId}/heartbeat`, { ttl_sec: ttlSec }).then(unwrap),
// //   release: (sessionId) => client.delete(`/edit-sessions/${sessionId}`).then(unwrap),

// //   resequenceTour: (tourId, payload) =>
// //     client.post(`/tours/${tourId}/resequence`, payload).then(unwrap),
// //   assignBooking: (bookingId, payload) =>
// //     client.post(`/bookings/${bookingId}/assign`, payload).then(unwrap),
// //   reassignBooking: (bookingId, payload) =>
// //     client.post(`/bookings/${bookingId}/reassign`, payload).then(unwrap),
// //   unassignBooking: (bookingId, payload) =>
// //     client.post(`/bookings/${bookingId}/unassign`, payload).then(unwrap),
// // };
